// How a job or quote number looks, on the settings screens (round 45).
//
// The client-side twin of the server's `renderJobNumber`
// (server/src/scheduling/jobNumbers.ts), kept tiny so the two cannot drift
// far, and only ever shown as an example: the server allocates the real
// number, skipping anything already taken. Four digits under every format
// (Nathan, 2026-10-13: "0001, 0002, 0003 ... for consistency").
export type NumberFormat = 'sequential' | 'prefixed' | 'yearly';

export const NUMBER_PAD = 4;

export function exampleNumber(
  format: NumberFormat,
  prefix: string,
  counter: number,
  year: number = new Date().getFullYear()
): string {
  const digits = String(counter).padStart(NUMBER_PAD, '0');
  if (format === 'sequential') return digits;
  if (format === 'yearly') return `${year}-${digits}`;
  return `${prefix}-${digits}`;
}

/** The three choices, with an example of each in the label. */
export function formatOptions(prefix: string): { value: NumberFormat; label: string }[] {
  return [
    { value: 'sequential', label: 'Plain number (0001, 0002, 0003)' },
    { value: 'prefixed', label: `Prefix and number (${prefix}-0001, ${prefix}-0002)` },
    { value: 'yearly', label: 'Year and number, restarting each January (2026-0001, 2026-0002)' },
  ];
}
